<template>
  <div>
    <div v-if="queueLoading">
      {{ $t("production_order_list.bodyprint_queue_table.loading") }}
    </div>
    <div v-else>
      <b>{{ $t("production_order_list.bodyprint_queue_items.header") }}</b>
      <div v-if="queueItems.length === 0" class="mt-3">
        {{ $t("production_order_list.bodyprint_queue_table.no_data") }}
      </div>
      <table
        v-else
        class="table-fixed w-full border-solid px-4 mt-3 data-table-right-section overflow-y-auto"
      >
        <thead>
          <tr>
            <th class="w-3/12 px-2 pb-2 text-left font-semibold">
              {{
                $t(
                  "production_order_list.bodyprint_queue_table.columns.retailer_code"
                )
              }}
            </th>
            <th class="w-3/12 px-2 pb-2 text-left font-semibold">
              {{
                $t(
                  "production_order_list.bodyprint_queue_table.columns.retailer"
                )
              }}
            </th>
            <th class="w-3/12 px-2 pb-2 text-left font-semibold">
              {{
                $t(
                  "production_order_list.bodyprint_queue_table.columns.bodyprint_date"
                )
              }}
            </th>
            <th class="w-3/12 px-2 pb-2 text-left font-semibold">
              {{
                $t(
                  "production_order_list.bodyprint_queue_table.columns.bodyprint_status"
                )
              }}
            </th>
            <th class="w-3/12 px-2 pb-2 text-left font-semibold">
              {{
                $t(
                  "production_order_list.bodyprint_queue_table.columns.order_count"
                )
              }}
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(queueItem, index) in queueItems"
            :key="index"
            @click="handleQueueItemClick(queueItem)"
            v-bind:class="[
              'cursor-pointer hover:bg-gray-50',
              selectedQueueItem && selectedQueueItem.id === queueItem.id
                ? 'font-bold'
                : 'font-normal',
              index === queueItems.length - 1 ? '' : 'border-b'
            ]"
          >
            <td class="py-3 px-2 text-left text-sm">
              {{ queueItem.retailer_code }}
            </td>
            <td class="py-3 px-2 text-left text-sm">
              {{ queueItem.retailer_name }}
            </td>
            <td class="py-3 px-2 text-left text-sm">
              {{ formatDate(queueItem.created_at) }}
            </td>
            <td class="py-3 px-2 text-left text-sm">
              {{
                $t(`general.status.bodyprint.${queueItem.status.toLowerCase()}`)
              }}
            </td>
            <td class="py-3 px-2 text-left text-sm">
              <span v-if="queueItem.order_count > 0" class="check-icon">✓</span>
              <span v-else>-</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ProductionOrderBodyprintQueueTable",
  props: {
    queueItems: {
      type: Array,
      default: () => []
    },
    queueLoading: {
      type: Boolean,
      default: false
    },
    selectedQueueItem: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleQueueItemClick(queueItem) {
      this.$emit("queue-item-selected", queueItem);
    },
    formatDate(date) {
      return moment(date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY");
    }
  }
};
</script>
